// Import all notification sound files
import notificationMp3 from "../Assets/notification.mp3";
import cabinChime from "../Assets/cabinchime.mp3";

// Import additional sound files from the home directory
import chicagoStation from "../pages/home/chicagostation.wav";
import doubleMdt from "../pages/home/doublemdt.wav";
import firePager from "../pages/home/firepager.wav";
import helloMdt from "../pages/home/hellomdt.wav";
import houseTone from "../pages/home/housetone.wav";
import ladderBell from "../pages/home/ladderbell.wav";
import mdtAlert from "../pages/home/mdtalert.wav";
import oldStationBuzz from "../pages/home/oldstationbuzz.wav";
import russoTone from "../pages/home/russotone.wav";
import seatBeltTone from "../pages/home/seatbelttone.wav";
import threeTone from "../pages/home/threetone.wav";
import twoTone from "../pages/home/twotone.wav";

/**
 * Available notification sounds configuration
 */
export const notificationSounds = [
  {
    name: "Seatbelt Tone",
    value: "seatbelttone.wav",
    file: seatBeltTone
  },
  {
    name: "Default Alert",
    value: "notification.mp3",
    file: notificationMp3
  },
  {
    name: "Cabin Chime",
    value: "cabinchime.mp3",
    file: cabinChime
  },
  {
    name: "Chicago Station",
    value: "chicagostation.wav",
    file: chicagoStation
  },
  {
    name: "Double MDT",
    value: "doublemdt.wav",
    file: doubleMdt
  },
  {
    name: "Fire Pager",
    value: "firepager.wav",
    file: firePager
  },
  {
    name: "Hello MDT",
    value: "hellomdt.wav",
    file: helloMdt
  },
  {
    name: "House Tone",
    value: "housetone.wav",
    file: houseTone
  },
  {
    name: "Ladder Bell",
    value: "ladderbell.wav",
    file: ladderBell
  },
  {
    name: "MDT Alert",
    value: "mdtalert.wav",
    file: mdtAlert
  },
  {
    name: "Old Station Buzz",
    value: "oldstationbuzz.wav",
    file: oldStationBuzz
  },
  {
    name: "Russo Tone",
    value: "russotone.wav",
    file: russoTone
  },
  {
    name: "Seatbelt Tone",
    value: "seatbelttone.wav",
    file: seatBeltTone
  },
  {
    name: "Three Tone",
    value: "threetone.wav",
    file: threeTone
  },
  {
    name: "Two Tone",
    value: "twotone.wav",
    file: twoTone
  }
];

/**
 * Get sound file by value
 * @param {string} soundValue - The value of the sound to get
 * @returns {string|null} - The sound file path or null if not found
 */
export const getSoundFile = (soundValue) => {
  const sound = notificationSounds.find(s => s.value === soundValue);
  return sound ? sound.file : null;
};

/**
 * Get sound name by value
 * @param {string} soundValue - The value of the sound to get
 * @returns {string} - The sound name or "Unknown Sound"
 */
export const getSoundName = (soundValue) => {
  const sound = notificationSounds.find(s => s.value === soundValue);
  return sound ? sound.name : "Unknown Sound";
};
